// import { Col, Flex, Row } from "antd";
// import React, { useState } from "react";
// import CustomHeader from "../../components/header/CustomHeader";
// import { IconArrowNarrowRight } from "@tabler/icons-react";
// import CustomModal from "../../components/modal/CustomModal";
// import { downloadLotteryCSV } from "./excel/LotteryReport";
// import api from "../../api";
// import { useToast } from "../../components/toast/toast";
// import ReportTicket from "./report-ticket";

// const Report = () => {
//   const [open, setOpen] = useState(false);
//   const [modalType, setModalType] = useState(null); // "lottery" | "award"
//   const [isLoading, setIsLoading] = useState(false);
//   const toast = useToast();

//   const cellStyle = {
//     background: "#f5f5f5",
//     padding: "24px",
//     borderRadius: 8,
//     border: "1px solid #e0e0e0",
//     display: "flex",
//     flexDirection: "row",
//     alignItems: "center",
//     justifyContent: "space-between",
//     cursor: "pointer",
//     transition: "0.2s",
//   };

//   const openModal = (type) => {
//     setModalType(type);
//     setOpen(true);
//   };

//   const closeModal = () => {
//     setOpen(false);
//     setModalType(null);
//   };

//   const handleDownload = async () => {
//     setIsLoading(true);
//     if (modalType === "lottery") {
//       const res = await api.report_lottery();
//       // console.log("report_lottery res --->", res);
//       if (res?.status === 200) {
//         await downloadLotteryCSV(res.data);
//         toast("Сугалааны тайлан татагдлаа", "success");
//       } else {
//         toast(res.data?.message || "Алдаа гарлаа", "error");
//       }
//     }
//     setIsLoading(false);
//     closeModal();
//   };

//   return (
//     <Flex vertical>
//       <CustomHeader title={"Тайлан"} />
//       <Row gutter={[16, 16]} style={{ width: "100%" }}>
//         <Col xs={24} sm={12} md={6}>
//           <div
//             style={cellStyle}
//             onClick={() => openModal("lottery")}
//             role="button"
//             tabIndex={0}
//           >
//             <h4 style={{ margin: 0 }}>Сугалааны товч тайлан татах</h4>
//             <IconArrowNarrowRight size={22} />
//           </div>
//         </Col>
//         <Col xs={24} sm={12} md={6}>
//           <ReportTicket />
//         </Col>
//         {/* <Col xs={24} sm={12} md={8}>
//           <div
//             style={cellStyle}
//             onClick={() => openModal("award")}
//             role="button"
//             tabIndex={0}
//           >
//             <h4 style={{ margin: 0 }}>Шагналын тайлан татах</h4>
//             <IconArrowNarrowRight size={22} />
//           </div>
//         </Col> */}
//         <Col xs={24} sm={12} md={6}>
//           <div
//             style={cellStyle}
//             onClick={() => openModal("salesRange")}
//             role="button"
//             tabIndex={0}
//           >
//             <h4 style={{ margin: 0 }}>Хугацаагаар борлуулалтын тайлан татах</h4>
//             <IconArrowNarrowRight size={22} />
//           </div>
//         </Col>
//       </Row>

//       <CustomModal
//         open={open}
//         title={
//           modalType === "lottery" ? "Сугалааны товч тайлан" : "Шагналын тайлан"
//         }
//         onCancel={closeModal}
//         onOk={handleDownload}
//         disabled={isLoading}
//       >
//         {modalType === "lottery" ? null : (
//           <div>Энд шагналын тайлангийн шүүлтүүрүүд байрлуул.</div>
//         )}
//       </CustomModal>
//     </Flex>
//   );
// };

// export default Report;

import { Col, Flex, Row, DatePicker } from "antd";
import React, { useState } from "react";
import CustomHeader from "../../components/header/CustomHeader";
import { IconArrowNarrowRight } from "@tabler/icons-react";
import CustomModal from "../../components/modal/CustomModal";
import { downloadLotteryCSV } from "./excel/LotteryReport";
import api from "../../api";
import { useToast } from "../../components/toast/toast";
import ReportTicket from "./report-ticket";
import dayjs from "dayjs";
import { downloadLotterySalesXLSX } from "./excel/LotterySalesXLSX";

const { RangePicker } = DatePicker;

const Report = () => {
  const [open, setOpen] = useState(false);
  const [modalType, setModalType] = useState(null); // "lottery", "salesRange"
  const [isLoading, setIsLoading] = useState(false);
  const [range, setRange] = useState(null); // [dayjs, dayjs]
  const toast = useToast();

  const cellStyle = {
    background: "#f5f5f5",
    padding: "24px",
    borderRadius: 8,
    border: "1px solid #e0e0e0",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    cursor: "pointer",
    transition: "0.2s",
  };

  const openModal = (type) => {
    setModalType(type);
    setOpen(true);
  };

  const closeModal = () => {
    setOpen(false);
    setModalType(null);
    setRange(null);
  };

  const handleDownload = async () => {
    setIsLoading(true);

    try {
      // ✅ 1) Сугалааны товч тайлан
      if (modalType === "lottery") {
        const res = await api.report_lottery();
        if (res?.status === 200) {
          await downloadLotteryCSV(res.data);
          toast("Сугалааны тайлан татагдлаа", "success");
        } else {
          toast(res.data?.message || "Алдаа гарлаа", "error");
        }
      }

      // ✅ 2) Range борлуулалтын тайлан
      if (modalType === "salesRange") {
        if (!range || range.length !== 2) {
          toast("Огнооны range сонгоно уу", "error");
          setIsLoading(false);
          return;
        }

        const payload = {
          range: [range[0].format("YYYY-MM-DD"), range[1].format("YYYY-MM-DD")],
        };

        const res = await api.report_lottery_sales_by_range(payload);

        // console.log("report_lottery_sales_by_range --->", res);
        if (res?.status === 200) {
          const rows = res.data?.data || [];
          await downloadLotterySalesXLSX({ rows }, payload.range);
          toast("Борлуулалтын тайлан татагдлаа", "success");
        } else {
          toast(res.data?.message || "Алдаа гарлаа", "error");
        }
      }
    } catch (err) {
      toast(err?.response?.data?.message || "Алдаа гарлаа", "error");
    }

    setIsLoading(false);
    closeModal();
  };

  return (
    <Flex vertical>
      <CustomHeader title={"Тайлан"} />

      <Row gutter={[16, 16]} style={{ width: "100%" }}>
        {/* Lottery Report */}
        <Col xs={24} sm={12} md={6}>
          <div
            style={cellStyle}
            onClick={() => openModal("lottery")}
            role="button"
            tabIndex={0}
          >
            <h4 style={{ margin: 0 }}>Сугалааны товч тайлан татах</h4>
            <IconArrowNarrowRight size={22} />
          </div>
        </Col>

        {/* Ticket Report */}
        <Col xs={24} sm={12} md={6}>
          <ReportTicket />
        </Col>

        {/* Range Sales Report */}
        <Col xs={24} sm={12} md={6}>
          <div
            style={cellStyle}
            onClick={() => openModal("salesRange")}
            role="button"
            tabIndex={0}
          >
            <h4 style={{ margin: 0 }}>Хугацаагаар борлуулалтын тайлан татах</h4>
            <IconArrowNarrowRight size={22} />
          </div>
        </Col>
      </Row>

      <CustomModal
        open={open}
        title={
          modalType === "lottery"
            ? "Сугалааны товч тайлан"
            : modalType === "salesRange"
              ? "Борлуулалтын тайлан"
              : "Тайлан"
        }
        onCancel={closeModal}
        onOk={handleDownload}
        disabled={isLoading}
      >
        {modalType === "salesRange" ? (
          <Flex vertical gap={12}>
            <div>Огнооны интервал сонгоод тайлан татна.</div>
            <RangePicker
              value={range}
              onChange={(v) => setRange(v)}
              format="YYYY-MM-DD"
              allowClear
              disabledDate={(d) => d && d.isAfter(dayjs(), "day")}
              style={{
                minHeight: "40px",
                width: "100%",
              }}
            />
          </Flex>
        ) : null}
      </CustomModal>
    </Flex>
  );
};

export default Report;
